export const events = {
  addBreakStart: 'Add break start',
  addBreakSubmit: 'Add break submit',
  addItemToShiftsScheduleStart: 'Add item to shifts schedule start',
  addRestDays: 'Add Rest Days',
  addNewSavedShiftStart: 'Add shifts management new saved shift start',
  addNewSavedShiftSubmit: 'Add shifts management new saved shift submit',
  addShiftStart: 'add_shift_start',
  addShiftSubmit: 'add_shift_submit',
  autoSchedulerStart: 'Auto scheduler start',
  autoSchedulerRun: 'Auto scheduler run',
  bulkDaySelected: 'Bulk day selected',
  bulkEmployeePeriodSelected: 'Bulk employee period selected',
  bulkFullTableSelected: 'Bulk full table selected',
  collapseCoverageSection: 'Collapse coverage section',
  deleteCoverageStart: 'Delete coverage start',
  deleteCoverageSubmit: 'Delete coverage submit',
  deleteBreakSubmit: 'Delete break submit',
  deleteRestDaySubmit: 'Delete Rest Day Submit',
  deleteNewSavedShiftStart: 'Delete shifts management saved shift start',
  deleteNewSavedShiftSubmit: 'Delete shifts management saved shift submit',
  deleteShiftStart: 'Delete shift start',
  deleteShiftSubmit: 'Delete shift submit',
  resizeCoverageHeader: 'Resize coverage header',
  editNewSavedShiftStart: 'Edit shifts management saved shift start',
  editNewSavedShiftSubmit: 'Edit shifts management saved shift submit',
  editShiftStart: 'edit_shift_start',
  editShiftSubmit: 'edit_shift_submit',
  expandCoverageSection: 'Expand coverage section',
  filterShiftManagementAddNewFilter: 'Filter shift management add new filter',
  filterShiftManagementReset: 'Reset shift management filters',
  filterShiftManagementStart: 'Filter shift management start',
  filterShiftManagementSubmit: 'Filter shift management submit',
  generateCoverageStart: 'Generate coverage start',
  generateCoverageSubmit: 'Generate coverage submit',
  goToBreaksSettings: 'Go to breaks settings',
  goToEmployees: 'Go to employees',
  goToShiftManagementAbsencesDetails: 'Go to shift management absences details',
  goToShiftManagementSettings: 'Go to shift management settings',
  goToWorkAreaStart: 'Go to shift management create workarea start',
  goToShiftsContextualMenu: 'Go to shifts contextual menu',
  goToDetailsShiftStart: 'Go to details shift start',
  goToDetailsShiftSubmit: 'Go to details shift submit',
  howToSetUpBreaksStart: 'How to set up breaks start',
  howToSetUpBreaksFinish: 'How to set up breaks finish',
  importEmployeesStart: 'Add employees to shift management start',
  importEmployeesSubmit: 'Add employees to shift management submit',
  newBreakStart: 'New break start',
  newBreakSubmit: 'New break submit',
  publishShiftManagementStart: 'Publish shift management start',
  publishShiftManagementSubmit: 'Publish shift management submit',
  requestPlanUpdate: 'Request Shift Management upsell',
  requestScheduleExportStart: 'Request shift management export start',
  requestScheduleExportSubmit: 'Request shift management export submit',
  requestYearlyExportStart: 'Request yearly balance export start',
  requestYearlyExportSubmit: 'Request yearly balance export submit',
  requestShiftManagementEmployees: 'Request Shift Management new page',
  selectShiftManagementView: 'Go to shift management view',
  addTemplateShiftManagementStart: 'Add template Shift Management start',
  addTemplateWeekShiftManagementStart: 'Add template week Shift Management start',
  addTemplateWeekShiftManagementSubmit: 'Add template week Shift Management submit',
  addCopyShiftsToAllTemplateShiftManagement: 'Add copy shifts to all template Shift Management',
  deleteTemplateWeekShiftManagementSubmit: 'Delete template week Shift Management submit',
  deleteTemplateShiftManagementSubmit: 'Delete template Shift Management submit',
  goToCoverageSection: 'Go to coverage section',
  addUnassignedShiftStart: 'Add unassigned shift start',
  addUnassignedShiftSubmit: 'Add unassigned shift submit',
  goToDetailsUnassignedShiftStart: 'Go to details unassigned shift start',
  assignEmployeesUnassignedShiftStart: 'Assign employees unassigned shift start',
  assignEmployeesUnassignedShiftSubmit: 'Assign employees unassigned shift submit',
  editUnassignedShiftStart: 'Edit unassigned shift start',
  editUnassignedShiftSubmit: 'Edit unassigned shift submit',
  deleteUnassignedShiftSubmit: 'Delete unassigned shift submit',
  goToShiftsSettings: 'Go to shifts settings',
  goToShifts: 'Go to shifts',
  orderEmployees: 'Order employees',
  openTimeInsightsSidepanelStart: 'Open time insights sidepanel start',
  openTimeInsightsSidepanelSubmit: 'Open time insights sidepanel submit',
  selectRangeTypeTimeInsights: 'Select range type time insights',
  viewOptionsStart: 'View options start',
  viewOptionsSubmit: 'View options submit',
  openSwapRequestApproval: 'Open swap request approval',
  submitSwapRequestApproval: 'Submit swap request approval',
  addTimeOffFromShiftStart: 'Add time off from shift start',
  editTimeOffFromShiftStart: 'Edit time off from shift start',
  deleteCoverage: 'Delete coverage',
}
